﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';

import {pageCurrentStepAction} from '../../State/actions';

import RawHtml from '../../UI/RawHtml';

import StepProgressBar from '../../UI/StepProgressBar';
import StepSection from '../../UI/StepSection';

import Step1Form from './Forms/Step1Form';
import Step2Form from './Forms/Step2Form';
import Step3Form from './Forms/Step3Form';
import Step4Form from './Forms/Step4Form';
import GuideResult from './Components/GuideResult';
import PensionChart from './Components/PensionChart';

import isInViewport from '../../Utils/isInViewport';
import {getEpiData} from '../../Utils/epiHelpers';

import definitions from '../../Style/LfStyleDefinitions';
import { mediaQuery, clearFix} from '../../Style/cssHelpers';

const guideSteps = [
    (props) => <Step1Form {...props}/>,
    (props) => <Step2Form {...props}/>,
    (props) => <Step3Form {...props}/>,
    (props) => <Step4Form {...props}/>,
    (props) => <GuideResult {...props}/>
];

class RetirementGuidePage extends React.Component {
    constructor(props) {
        super(props);
        this.heroEl = null;

        this.epiHeaderData = this.getHeaderData();
        // this.heading = getEpiData('heading', this.props.mountRootId);
        // this.preamble = getEpiData('preamble', this.props.mountRootId);
    }

    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    ref = React.createRef();

    getHeaderData() {
        return {
            headings: {
                startHeading: getEpiData('heading', this.props.mountRootId),
                resultPensionConsultingHeader: getEpiData('heading-pension-consulting', this.props.mountRootId),
            },
            preambles: {
                startPreamble: getEpiData('preamble', this.props.mountRootId),
                resultPreamble: getEpiData('result-preamble', this.props.mountRootId),
                resultPensionConsultingPreamble: getEpiData('preamble-pension-consulting', this.props.mountRootId),
            },
            links: {
                resultPensionConsultingLink: getEpiData('link-pension-consulting', this.props.mountRootId),
            }
        };
    }


    render() {
        const CurrentStep = guideSteps[this.props.step];

        return (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <HeroWrapper>
                    <Hero ref={el => this.heroEl = el}>
                        {this.props.step <= guideSteps.length - 2 &&
                            <React.Fragment>
                                <h1>{this.epiHeaderData.headings.startHeading}</h1>

                                <Preamble currentStep={this.props.step}>
                                    <RawHtml>
                                        {this.epiHeaderData.preambles.startPreamble}
                                    </RawHtml>
                                </Preamble>

                                <StepProgressBar
                                    stepLabels={[]}
                                    stepCount={guideSteps.length - 1}
                                    activeStep={this.props.step}
                                    textColor="white"
                                    responsiveHideStepOne={true}
                                    fadeOutOnLastStep={true}
                                    edgeMargin={true}
                                    clickableSteps={true}
                                    onStepClick={(step) => this.props.setCurrentStep(step)}
                                />
                            </React.Fragment>
                        }

                        {this.props.step > guideSteps.length - 2 &&
                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                                <ChartHeading>Ditt resultat</ChartHeading>

                                <ChartWrapper>
                                    <PensionChart
                                        headerData={this.epiHeaderData}
                                        chartId="lf-pension-chart"
                                    />
                                </ChartWrapper>
                            </motion.div>
                        }
                    </Hero>
                </HeroWrapper>

                <GuideWrapper>
                    <StepSection sectionId={this.props.step}>
                        &nbsp; { /* this &nbsp is needed - prevents the layout from collapsing */}
                        {/* TODO: refactor to avoid this &nbsp*/}
                        <SectionWrapper>
                            <CurrentStep
                                submitOnStep={guideSteps.length - 1}
                                scrollToTopOnContinue={() => !isInViewport(this.heroEl)}
                                epiHeaderData={this.epiHeaderData}
                            />
                        </SectionWrapper>
                    </StepSection>
                </GuideWrapper>
            </motion.div>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading,
        step: state.pageCurrentStep
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentStep: (step) => dispatch(pageCurrentStepAction(step))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RetirementGuidePage);


// styles

const HeroWrapper = styled.div`
    background-color: ${definitions.colors.blueBackground};
    color: white;
`;

const Hero = styled.div`
    position: relative;
    width: 100%;
    max-width: 1350px;

    margin: 0 auto;
    margin-top: -1px;

    padding: 70px 5% 70px 5%;

    ${mediaQuery.medium(`
        padding: 60px 5% 60px 5%;
    `)};

    ${mediaQuery.small(`
        padding: 20px 10px 20px 10px;
    `)};

    background-color: ${definitions.colors.blueBackground};
    color: white;

    font-family: ${definitions.fonts.heading};
    text-align: center;

    h1 {
        ${mediaQuery.small(`
            font-size: 30px;
        `)};
    }
`;

const Preamble = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'currentStep'
})`
    max-width: 70%;
    margin: 40px auto 40px auto;
    font-size: 22px;

    ${props => mediaQuery.small(`
        transition: max-height 350ms ease-out, opacity 350ms ease-out;

        ${props.currentStep > 0 ? `
            max-height: 0;
            overflow: hidden;
            opacity: 0;
        ` : `
            max-height: 300px;
            overflow: auto;
            opacity: 1;
        `};

        margin: 16px 0 0 0;
        max-width: 100%;

        font-size: 16px;
        line-height: 1.5;
    `)};
`;

const GuideWrapper = styled.div`
    position: relative;
    ${clearFix()}
`;

const SectionWrapper = styled.div`
    position: relative;

    ${'' /* obs kolla så att nedanstående ändring ej strular till själva guide-stegen */}
    margin: 20px 100px 180px 100px;
    ${'' /* margin: 0 100px 180px 100px; */}
    overflow: hidden;

    text-align: center;

    ${mediaQuery.small(`
        margin: 0 auto;
        padding-left: 10px;
        padding-right: 10px;
    `)};
`;

const ChartHeading = styled.h1`
    margin-bottom: 50px;

    ${mediaQuery.medium(`
        margin-bottom: 30px;
    `)};

    ${mediaQuery.small(`
        margin-bottom: 15px;
    `)};
`;

const ChartWrapper = styled.div`
    overflow: hidden;
`;
